"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var createRange_1 = require("./createRange");
var normalizeRect_1 = require("../utils/normalizeRect");
/**
 * Get bounding rect of this position
 * @param position The positioin to get rect from
 */
function getPositionRect(position) {
    if (!position) {
        return null;
    }
    var range = createRange_1.default(position);
    // 1) try to get rect using range.getBoundingClientRect()
    var rect = range.getBoundingClientRect && normalizeRect_1.default(range.getBoundingClientRect());
    if (rect) {
        return rect;
    }
    // 2) try to get rect using range.getClientRects
    position = position.normalize();
    var rects = range.getClientRects && range.getClientRects();
    rect = rects && rects.length == 1 && normalizeRect_1.default(rects[0]);
    if (rect) {
        return rect;
    }
    // 3) if node is text node, try inserting a SPAN and get the rect of SPAN for others
    if (position.node.nodeType == 3 /* Text */) {
        var document_1 = position.node.ownerDocument;
        var span = document_1.createElement('SPAN');
        span.innerHTML = '\u200b';
        range = createRange_1.default(position);
        range.insertNode(span);
        rect = span.getBoundingClientRect && normalizeRect_1.default(span.getBoundingClientRect());
        span.parentNode.removeChild(span);
        if (rect) {
            return rect;
        }
    }
    // 4) try getBoundingClientRect on element
    var element = position.element;
    if (element && element.getBoundingClientRect) {
        rect = normalizeRect_1.default(element.getBoundingClientRect());
        if (rect) {
            return rect;
        }
    }
    return null;
}
exports.default = getPositionRect;
//# sourceMappingURL=getPositionRect.js.map